document.documentElement.classList.remove('no-js');

// Native lazy loading can fetch catalog artwork far below the first screen.
// Reserve its existing media box, then load shortly before it enters view.
function initializeDeferredMedia(root = document) {
  const templates = root.querySelectorAll('template[data-deferred-media]');
  const reveal = (template) => template.replaceWith(template.content.cloneNode(true));
  if (!('IntersectionObserver' in window)) {
    templates.forEach(reveal);
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const template = entry.target.querySelector('template[data-deferred-media]');
      if (template) reveal(template);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '300px 0px' });
  templates.forEach((template) => observer.observe(template.parentElement));
}
initializeDeferredMedia();
document.addEventListener('shopify:section:load', (event) => initializeDeferredMedia(event.target));

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-localization-select]');
  if (select) select.form?.submit();

  const autoSubmit = event.target.closest('[data-auto-submit]');
  if (autoSubmit) autoSubmit.form?.submit();

  const variant = event.target.closest('[data-variant-selector]');
  if (variant) {
    const url = new URL(variant.dataset.productUrl, window.location.origin);
    url.searchParams.set('variant', variant.value);
    window.location.assign(url.toString());
  }
});

document.addEventListener('input', (event) => {
  const input = event.target.closest('[data-quantity-input]');
  if (!input) return;

  const minimum = Number(input.min || 1);
  const step = Number(input.step || 1);
  const value = Number(input.value || 0);
  input.setCustomValidity('');

  if (value < minimum || (value - minimum) % step !== 0) {
    input.setCustomValidity(input.dataset.quantityError || `Use a quantity of at least ${minimum} in increments of ${step}.`);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const openMenu = document.activeElement?.closest('.site-header details[open]');
  if (!openMenu) return;

  openMenu.removeAttribute('open');
  openMenu.querySelector(':scope > summary')?.focus();
});

document.addEventListener('click', (event) => {
  const chatLink = event.target.closest('[data-open-shopify-chat]');
  if (chatLink) {
    const chatButton = document.querySelector('shopify-chat')?.shadowRoot?.querySelector('[part="activator"]');
    if (chatButton) {
      event.preventDefault();
      chatButton.click();
      return;
    }
  }

  document.querySelectorAll('.main-nav--desktop details[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
